var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Driving-School-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.00.-Students-(Admin)",
    transform: "translate(-1142.000000, -135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap_vert_black_24dp-2",
    transform: "translate(1142.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9415344,6.1425 L9.15153441,8.9325 C8.83153441,9.2425 9.05153441,9.7825 9.50153441,9.7825 L11.2915344,9.7825 L11.2915344,15.7925 C11.2915344,16.3425 11.7415344,16.7925 12.2915344,16.7925 C12.8415344,16.7925 13.2915344,16.3425 13.2915344,15.7925 L13.2915344,9.7825 L15.0815344,9.7825 C15.5315344,9.7825 15.7515344,9.2425 15.4315344,8.9325 L12.6415344,6.1425 C12.4515344,5.9525 12.1315344,5.9525 11.9415344,6.1425 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(12.291534, 11.396250) scale(1, -1) translate(-12.291534, -11.396250) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDown);
export default __webpack_public_path__ + "static/media/sort-arrow-down.c0246e24.svg";
export { ForwardRef as ReactComponent };